import React from "react";
import { disability_supplement } from "utils/constants/data";

function DisabilitySupplement() {
  const disabilitySupplement = disability_supplement(false);

  return (
    <section>
      <div className="max-w-lg sm:max-w-xl md:max-w-2xl lg:max-w-3xl xl:max-w-4xl 2xl:max-w-5xl mx-auto px-4 py-4 sm:py-12 space-y-8 mt-28 md:mt-32 lg:mt-36">
        <div className="space-y-2 sm:space-y-4 text-center">
          <p className="text-2xl sm:text-3xl lg:text-4xl font-bold">
            Disability Supplement
          </p>
          <p className="text-sm md:text-lg italic">
            (Courtesy NCVER Standard enrolment questions example for Release 8.0
            for VET Providers)
          </p>
        </div>
        <div className="py-6 space-y-2 sm:space-y-4 border-black border-y-4">
          <p className="text-lg sm:text-xl lg:text-2xl font-bold">
            Introduction
          </p>
          <p className="px-4 sm:px-6 md:px-8 lg:px-10 text-base sm:text-lg">
            The purpose of the Disability Supplement is to provide additional
            information to assist with answering the disability question.
          </p>
        </div>
        <div className="space-y-2 sm:space-y-4">
          <p className="text-base  sm:text-lg lg:text-xl font-bold">
            If you indicated the presence of a disability, impairment or
            long-term condition, please select the area(s) in the following
            list:
          </p>
        </div>
        {disabilitySupplement.map((item, i) => (
          <div className="px-4 sm:px-6 md:px-8 lg:px-10 space-y-2 sm:space-y-4">
            {item?.title && (
              <div className="flex flex-row items-center space-x-4">
                {item.title}
              </div>
            )}
            {item?.description && (
              <div className="space-y-2 md:space-y-4 text-justify text-sm  sm:text-base lg:text-lg">
                {item.description}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}

export default DisabilitySupplement;
